import { DatePicker, Form, Input, Modal, Typography } from 'antd';
import { useEffect } from 'react';

export default function CompleteFailedPayoutModal({
  open,
  setOpen,
  payoutId,
  loading,
  onOk,
}) {
  const { Text } = Typography;
  const [form] = Form.useForm();
  const completedDate = Form.useWatch('completedDate', form);
  const notes = Form.useWatch('notes', form);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, payoutId]);

  return (
    <Modal
      title="Complete payout"
      open={open}
      onCancel={() => setOpen(false)}
      onClose={() => setOpen(false)}
      okText="Complete Payout"
      confirmLoading={loading}
      okButtonProps={{
        disabled: !completedDate || !notes?.trim(),
      }}
      cancelButtonProps={{ disabled: loading }}
      maskClosable={!loading}
      onOk={() => form.submit()}
      centered
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <Text>
          Payout <Text strong>{payoutId}</Text> will move to{' '}
          <Text strong>Payout Completed</Text>, along with its invoices and
          transactions.
        </Text>
        <Text style={{ fontSize: 12 }} italic>
          Note: This is the same change the batch update file performs. Provide
          the date the contributor was actually paid and why the payout is being
          completed manually.
        </Text>
      </div>
      <Form
        form={form}
        layout="vertical"
        style={{ margin: '16px 0 0' }}
        onFinish={(values) =>
          onOk(payoutId, {
            // Sent as UTC midnight so the picked calendar date is not shifted
            // by the browser timezone.
            completedDate: values.completedDate.format(
              'YYYY-MM-DD[T]00:00:00[Z]',
            ),
            notes: values.notes.trim(),
          })
        }
      >
        <Form.Item
          name="completedDate"
          label="Completion date"
          rules={[
            { required: true, message: 'Please select a completion date' },
          ]}
        >
          <DatePicker style={{ width: '60%' }} disabled={loading} />
        </Form.Item>
        <Form.Item
          name="notes"
          label="Notes"
          rules={[
            {
              required: true,
              whitespace: true,
              message: 'Please enter notes for this payout completion',
            },
          ]}
        >
          <Input.TextArea
            rows={4}
            maxLength={500}
            showCount
            disabled={loading}
            placeholder="Reason for completing this failed payout"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
